// Compartilhamento de texto — extraído do padrão inline já usado em useCodigoIndicacao.ts,
// generalizado pra qualquer texto (não só o link de indicação).

export async function copyToClipboard(text: string): Promise<void> {
    await navigator.clipboard.writeText(text);
}

export function shareWhatsapp(text: string): void {
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
}

export const WHATSAPP_WEB = 'https://web.whatsapp.com/';

/**
 * Abre o WhatsApp sem texto nenhum, para colar.
 *
 * É a saída para mensagem grande: `wa.me/?text=` não entrega o que passa de ~1.800
 * caracteres (ver LIMITE_WHATSAPP_LINK em mensagemCobranca.ts) e falha em silêncio
 * — a mensagem "não aparece". Copiar e colar não tem limite.
 */
export function abrirWhatsappVazio(): void {
    window.open(WHATSAPP_WEB, '_blank');
}

/**
 * Celular ou computador? Decide por onde o WhatsApp abre.
 *
 * O iPad se apresenta como Mac desde o iPadOS 13 — quem entrega é o toque.
 */
export function ehCelular(
    ua: string = typeof navigator !== 'undefined' ? navigator.userAgent : '',
    pontosDeToque: number = typeof navigator !== 'undefined' ? navigator.maxTouchPoints || 0 : 0,
): boolean {
    return /Android|iPhone|iPad|iPod|Mobile/i.test(ua) || (/Macintosh/.test(ua) && pontosDeToque > 1);
}

/**
 * O Chrome do Windows descarta calado link de app com mais de 2.048 caracteres
 * — não abre nada e não avisa. A margem cobre as aspas que ele acrescenta.
 */
export const LIMITE_LINK_APP_WHATSAPP = 2000;

/**
 * Link que abre o app do WhatsApp instalado no computador.
 *
 * Com o texto dentro quando ele cabe; senão, o app abre sem texto e a mensagem
 * vai pela área de transferência — quem chama copia antes.
 */
export function linkAppWhatsapp(texto: string): string {
    const comTexto = `whatsapp://send?text=${encodeURIComponent(texto)}`;
    return comTexto.length <= LIMITE_LINK_APP_WHATSAPP ? comTexto : 'whatsapp://send';
}
